import {
    types
} from './types';
import firebase from '../firebase/firebase';
import {
    toArray
} from '../utils/lodashUtils';

const moment = require('moment-timezone');

const db = firebase.database();

export const getDBServices = () => async dispatch => {
    const onGetServices = (snap) => {
        let services = [];

        snap.forEach(serviceSnap => {
            if (serviceSnap) {
                services.push(serviceSnap.val());
            }
        });

        dispatch({
            type: types.GET_ALL_SERVICES,
            payload: services
        });
    }
    const servicesRef = db.ref(`/services`);
    servicesRef.off();
    servicesRef.on('value', onGetServices, e => console.log); // When there is a change to the service by a cloud function, trigger a state change in the app
};

export const getDBServiceCategories = () => async dispatch => {
    const onGetCategories = (snap) => {
        let categories = [];

        snap.forEach(categorySnap => {
            if (categorySnap) {
                categories.push(categorySnap.val());
            }
        });

        dispatch({
            type: types.GET_ALL_SERVICE_CATEGORIES,
            payload: categories
        });
    }

    db.ref(`/serviceCategories`).once('value', onGetCategories, e => console.log);
};

// export const getDBServiceCategory = (id) => async dispatch => {
//     const onGetCategory = (snap) => {
//         let categories = [];

//         snap.forEach( category => {
//             if (category){
//                 categories.push(category);
//             }
//         });

//         dispatch ({
//             type: types.GET_ALL_SERVICE_CATEGORIES,
//             payload: categories
//         });
//     }

//     db.ref(`/serviceCategories/${id}`).once('value', onGetCategory);
// };

export const setSelectedService = (service) => {
    if (service) {
        return {
            type: types.SET_SELECTED_SERVICE_SUCCESS,
            payload: service
        }
    } else {
        return {
            type: types.SET_SELECTED_SERVICE_FAIL,
            payload: null
        }
    }
};

export const getDBServiceModules = () => async dispatch => {
    const onGetModules = (snap) => {
        let modules = [];

        snap.forEach(moduleSnap => {
            if (moduleSnap) {
                modules.push(moduleSnap.val());
            }
        });

        dispatch({
            type: types.GET_ALL_SERVICE_MODULES,
            payload: modules
        });
    }

    db.ref(`/serviceModules`).once('value', onGetModules, e => console.log);
};

export const getServiceModules = (serviceId) => dispatch => {
    db.ref(`/services/${serviceId}/modules`).once('value', modulesSnap => {
        let modules = [];
        toArray(modulesSnap.val()).map(async module => {
            try {
                let serviceModuleSnap = await db.ref(`serviceModules`).once('value');

                serviceModuleSnap.forEach(serviceModule => {
                    // console.log('MODULES COMPARISON', serviceModule.val()._id, module.type)
                    // console.log('SERVICE MODULE IMAGE?', serviceModule.val());

                    if (serviceModule.val()._id === module.type) {
                        modules.push({ ...module,
                            bulletImageURL: serviceModule.val().bulletImageURL,
                            moduleInstanceDescription: serviceModule.val().description,
                            moduleOrder: serviceModule.val().order
                        });
                    }
                })
                // console.log('MODULES in async call', modules);
                dispatch({
                    type: types.GET_SERVICE_MODULE_SUCCESS,
                    payload: modules,
                    serviceId,
                })
            } catch (e) {
                console.log('ERROR:', e);
            }
        });

        // console.log('MODULES @ SERVICE ACTIONS', modules);
    }, e => {
        console.log('FIREBASE ERROR:', e)
    });
}

export const filterServicesByStatus = (userData) => dispatch => {
    // console.log('FILTERING SERVICES', userData.services);

    // DETERMINE CLIENT SERVICES
    if (userData && userData.services && userData.services.length > 0) {
        // 1. LOOP OVER CLIENT SERVICES

        userData.services.map(service => {
            let isClientServiceActive = false;
            let isClientServicePending = false;
            let isClientServiceInactive = true; // assume true to start and rule out other options
            let isClientServiceCancelled = false;
            service.activePeriods.map(activePeriod => {
                const utcActivePeriodStart = activePeriod.utcActivePeriodStartTimestamp;
                const utcActivePeriodEnd = activePeriod.utcActivePeriodEndTimestamp;

                if (moment.utc().format('x') > utcActivePeriodStart && moment.utc().format('x') < utcActivePeriodEnd) {
                    isClientServiceActive = true;
                    isClientServiceInactive = false;
                }

                // IF ANY START DATE IS GREATER THAN THE UTC TIME THEN IT IS PENDING OTHERWISE IT IS INACTIVE IF THERE IS NO START DATES GREATER THAN UTC NOW
                if (moment.utc().format('x') < utcActivePeriodStart) {
                    isClientServicePending = true;
                    isClientServiceInactive = false;
                }

                if (activePeriod.status === 'cancelled') {
                    isClientServiceInactive = false;
                    isClientServiceCancelled = true;
                }
            });

            // ADD SERVICE TO CORRECT LIST BASED ON WHAT WAS DETERMINED - can only choose one
            if (isClientServiceActive) {
                // console.log('ADDING ACTIVE SERVICE', service);
                dispatch({
                    type: types.ADD_ACTIVE_SERVICE_SUCCESS,
                    payload: service
                });
                // this.statePush('activeServices', service);
            } else if (isClientServicePending) {
                // console.log('ADDING PENDING SERVICE', service);
                dispatch({
                    type: types.ADD_PENDING_SERVICE_SUCCESS,
                    payload: service
                });
                // this.statePush('pendingServices', service);
            } else if (isClientServiceInactive) {
                // console.log('ADDING INACTIVE SERVICE', service);
                dispatch({
                    type: types.ADD_INACTIVE_SERVICE_SUCCESS,
                    payload: service
                });
                // this.statePush('inactiveServices', service);
            } else if (isClientServiceCancelled) {
                // console.log('ADDING CANCELLED SERVICE', service);

                dispatch({
                    type: types.ADD_CANCELLED_SERVICE_SUCCESS,
                    payload: service
                });
            }
        });
    }

    return {
        type: types.ADD_SERVICE_BY_STATUS_FAIL
    }
}

export const clearServiceStatuses = () => {
    return {
        type: types.CLEAR_SERVICE_STATUSES
    }
}

export const saveServiceRating = ({
    serviceId,
    clientUid,
    rating
}) => dispatch => {
    let updates = {};
    // const ratingId = db.ref().push().key;
    updates[`serviceRatings/${clientUid}/clientUid`] = clientUid;
    updates[`serviceRatings/${clientUid}/serviceId`] = serviceId;
    updates[`serviceRatings/${clientUid}/rating`] = rating;
    db.ref().update(updates)
        .then(() => {
            // ONCE THE DATA IS SAVED TO DB FETCH IT AND PLACE IT IN THE STORE
            dispatch(getServiceRatingForUser({
                serviceId,
                clientUid
            }));
        })
        .catch(console.log);
}

export const saveServiceReview = ({
    serviceId,
    clientUid,
    review
}) => dispatch => {
    let updates = {};
    // const reviewId = db.ref().push().key;
    updates[`serviceReviews/${clientUid}/clientUid`] = clientUid;
    updates[`serviceReviews/${clientUid}/serviceId`] = serviceId;
    updates[`serviceReviews/${clientUid}/review`] = review;
    db.ref().update(updates)
        .then(() => {
            dispatch(getServiceReviewForUser({
                serviceId,
                clientUid
            }));
        })
        .catch(console.log);
}

const getServiceReviews = (serviceId) => {
    return new Promise((resolve, reject) => {
        const serviceReviewQuery = db.ref(`serviceReviews`).orderByChild('serviceId').equalTo(serviceId);
        serviceReviewQuery.once('value', snap => {
            resolve(snap);
        }, (error) => {
            reject(new Error(error));
        })
    });
}

export const getAllServiceReviews = ({
    serviceId,
    clientUid
}) => dispatch => {
    getServiceReviews(serviceId)
        .then((serviceReviewsSnapshot) => {
            serviceReviewsSnapshot.forEach(reviewDataSnap => {
                dispatch({
                    type: types.GET_ALL_SERVICE_REVIEWS_SUCCESS,
                    payload: ratingDataSnap.val().review
                })
            })
        })
        .catch(console.log)
}

export const getServiceReviewForUser = ({
    serviceId,
    clientUid
}) => dispatch => {
    getServiceReviews(serviceId)
        .then((serviceReviewsSnapshot) => {
            serviceReviewsSnapshot.forEach(reviewDataSnap => {
                const reviewData = reviewDataSnap.val();
                if (reviewData.clientUid === clientUid) {
                    dispatch({
                        type: types.GET_SERVICE_REVIEW_FOR_USER_SUCCESS,
                        payload: reviewData.review,
                        serviceId
                    })
                }
            })
        })
        .catch(console.log)
}

const getServiceRatings = (serviceId) => {
    return new Promise((resolve, reject) => {
        const serviceRatingsRef = db.ref('serviceRatings');
        const serviceRatingsQuery = serviceRatingsRef.orderByChild('serviceId').equalTo(serviceId);
        serviceRatingsQuery.once('value', snap => {
            resolve(snap);
            console.log('GOT RATING', snap.val());
        }, (error) => {
            console.log(error)
            reject(new Error(error));
        })
    });
}

export const getAllServiceRatings = ({
    serviceId,
    clientUid
}) => dispatch => {
    getServiceRatings(serviceId)
        .then((serviceRatingsSnapshot) => {
            serviceRatingsSnapshot.forEach(ratingDataSnap => {
                dispatch({
                    type: types.GET_ALL_SERVICE_RATINGS_SUCCESS,
                    payload: ratingDataSnap.val().rating,
                    serviceId,
                })
            })
        })
        .catch(console.log)
}

export const getServiceRatingForUser = ({
    serviceId,
    clientUid
}) => dispatch => {
    getServiceRatings(serviceId)
        .then((serviceRatingsSnapshot) => {
            serviceRatingsSnapshot.forEach(ratingDataSnap => {
                const ratingData = ratingDataSnap.val();
                console.log('RATING DATA', ratingData);

                if (ratingData.clientUid === clientUid) {
                    dispatch({
                        type: types.GET_SERVICE_RATING_FOR_USER_SUCCESS,
                        payload: ratingData.rating
                    })
                }
            })
        })
        .catch(console.log)
}


// WEBPACK FOOTER //
// ./src/js/actions/service-actions.js